import * as React from 'react';
import { Dialog } from '@progress/kendo-react-dialogs';

export interface ISystemPopupProps {
    popupTitle?: string,
    popupWidth?: any,
    popupHeight?: any,
    minHeight?: string
    visible?: boolean
    showButton?: boolean
    showBanner?: boolean
    onClose?(): void
    children?: any
    banner?: any
    showCloseButton: boolean
}

export default class SystemPopup extends React.Component<ISystemPopupProps, any, any> {
    static defaultProps = {
        showBanner: false,
        visible: false,
        minHeight: "300px",
        minWidth: "800px",
        popupWidth: "950px",
        popupHeight: "auto",
        showCloseButton: true
    }

    constructor(props: ISystemPopupProps) {
        super(props)
    }

    render() {
        return (
            <div className="popupWrapper">
                {this.props.visible &&
                    <Dialog className="Top-popup" title={this.props.popupTitle} onClose={this.props.onClose} width={this.props.popupWidth} height={this.props.popupHeight} style={{ minHeight: "300px" }}>
                        {this.props.showBanner && this.props.banner}
                        {this.props.showCloseButton == true?<button className="popup-close-btn" onClick={this.props.onClose}><span className="icon-close"></span></button>:""}
                        {this.props.children}
                    </Dialog>}
            </div>
        );
    }
}